import { AxiosError } from 'axios';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { usePostManualTreeChapterAdd } from '../../../../../../api/manual-tree/manual-tree';
import { ErrorInfo } from '../../../../../../api/model';
import { useDefaultOptions } from '../../../../../../hooks/api';
import ErrorModal from '../../../../../modules/ErrorModal';
import SpinnerModal from '../../../../../modules/SpinnerModal';

type TreeProps = {
  productionId: number | undefined;
};
function SectionChapterMenuAdd({ productionId }: TreeProps) {
  const {
    t,
    i18n: { language },
  } = useTranslation();
  const options = useDefaultOptions(language);
  const { data, mutateAsync, isSuccess, isLoading, isError, error } = usePostManualTreeChapterAdd<
    AxiosError<ErrorInfo>,
    unknown
  >(options);

  const [displayAddError, setDisplayAddError] = useState(false);
  const handlePreview = async () => {
    await mutateAsync({ productionId: Number(productionId) });
  };

  useEffect(() => {
    if (isSuccess) {
      if (productionId) {
        const basePath = process.env.REACT_APP_ROUTER_BASEPATH || '';
        window.location.href = `${basePath}/${language}/productions/sections/${productionId}/ps?section_id=${Number(
          data.data.section_id
        )}`;
      }
    }
  }, [isSuccess, productionId, language, data?.data.section_id]);

  useEffect(() => {
    setDisplayAddError(isError);
  }, [isError]);

  return (
    <>
      <li
        onClick={async () => {
          await handlePreview();
        }}
      >
        <i className="fa-solid fa-circle-plus" />
        {t('章追加')}
      </li>
      {/* スピナーモーダル */}
      {isLoading && <SpinnerModal />}
      {/* 章追加エラー */}
      {displayAddError && <ErrorModal error={error} onClickOk={() => setDisplayAddError(false)} />}
    </>
  );
}
export { SectionChapterMenuAdd };
